import { setRemoteParticipants } from './actions';
import { isFilmstripScrollVisible } from './functions';
import { getParticipantsByCameraState } from "context/participants/functions";
import { getVirtualScreenshareParticipantOwnerId, getActiveSpeakersToBeDisplayed, } from "../base/participants/functions";
import { pull } from "lodash";
export function updateRemoteParticipants(store, force, participantId) {
    const state = store.getState();
    let reorderedParticipants = [];
    const { sortedRemoteVirtualScreenshareParticipants } = state["features/base/participants"];
    if (!isFilmstripScrollVisible(state) && !sortedRemoteVirtualScreenshareParticipants.size && !force) {
        if (participantId) {
            const { remoteParticipants } = state["features/filmstrip"];
            reorderedParticipants = [...remoteParticipants, participantId];
            store.dispatch(setRemoteParticipants(Array.from(new Set(reorderedParticipants))));
        }
        return;
    }
    const { fakeParticipants, sortedRemoteParticipants } = state["features/base/participants"];
    const remoteParticipants = new Map(sortedRemoteParticipants);
    const screenShareParticipants = sortedRemoteVirtualScreenshareParticipants ? [...sortedRemoteVirtualScreenshareParticipants.keys()] : [];
    const sharedVideos = fakeParticipants ? Array.from(fakeParticipants.keys()) : [];
    const speakers = getActiveSpeakersToBeDisplayed(state);
    const { active, inactive } = getParticipantsByCameraState(state);
    const participantsList = [...active, ...inactive];
    for (const screenshare of screenShareParticipants) {
        const ownerId = getVirtualScreenshareParticipantOwnerId(screenshare);
        remoteParticipants.delete(ownerId);
        remoteParticipants.delete(screenshare);
        speakers.delete(ownerId);
        pull(participantsList, ownerId);
    }
    for (const sharedVideo of sharedVideos) {
        remoteParticipants.delete(sharedVideo);
    }
    for (const speaker of speakers.keys()) {
        remoteParticipants.delete(speaker);
    }
    const participantsWithScreenShare = screenShareParticipants.reduce((acc, screenshare) => {
        const ownerId = getVirtualScreenshareParticipantOwnerId(screenshare);
        acc.push(ownerId);
        acc.push(screenshare);
        return acc;
    }, []);
    reorderedParticipants = [...participantsWithScreenShare, ...sharedVideos, ...participantsList];
    store.dispatch(setRemoteParticipants(Array.from(new Set(reorderedParticipants))));
}
export function updateRemoteParticipantsOnLeave(store, participantId = null) {
    if (!participantId) {
        return;
    }
    const state = store.getState();
    const { remoteParticipants } = state["features/filmstrip"];
    const reorderedParticipants = Array.from(new Set(remoteParticipants));
    const screenshareOwner = getVirtualScreenshareParticipantOwnerId(participantId);
    if (screenshareOwner) {
        const { active, inactive } = getParticipantsByCameraState(state);
        if (inactive.includes(screenshareOwner)) {
            const screenShareCount = reorderedParticipants.length - (active.length + inactive.length);
            pull(reorderedParticipants, screenshareOwner);
            reorderedParticipants.splice(screenShareCount * 2 + active.length, 0, screenshareOwner);
        }
    }
    pull(reorderedParticipants, participantId);
    store.dispatch(setRemoteParticipants(reorderedParticipants));
}
/**
 * Returns whether tileview is completely disabled.
 *
 * @param {IReduxState} state - Redux state.
 * @returns {boolean} - Whether tileview is completely disabled.
 */
export function isTileViewModeDisabled(state) {
    const { tileView = {} } = state['features/base/config'];
    return tileView.disabled;
}
